export const intl = {
    isInternationalized: true
  };
